import { DarePlatform } from 'root/src/shared/@types/platforms';
import { maxBy } from 'remeda';
import { isViewershipPlatform } from 'root/src/shared/platforms/guards/platform.guards';
import { platformsToViewershipPlatforms } from 'root/src/shared/util/platformHelpers';
const getBreakpoint = (breakpoints, count) => {
    const breakpointsSorted = breakpoints.sort((a, b) => a.viewershipCount - b.viewershipCount);
    if (breakpointsSorted.length === 0)
        return Infinity;
    const bHead = breakpointsSorted[0];
    const [, ...bTail] = breakpointsSorted;
    const getBreakpointI = (breakpointsI, currentHighest = bHead) => {
        if (breakpointsI.length === 0) {
            if (count > currentHighest.viewershipCount)
                return Infinity;
            return currentHighest.maxDares;
        }
        const head = breakpointsI[0];
        const [, ...tail] = breakpointsI;
        if (count > head.viewershipCount) {
            return getBreakpointI(tail);
        }
        if (count > currentHighest.viewershipCount) {
            return head.maxDares;
        }
        return currentHighest.maxDares;
    };
    return getBreakpointI(bTail);
};
export function calculateMaxDaresByPlatform({ campaign, platform, averageCcv, averageYoutubeViews, averageYoutubeShortsViews, tiktokFollowers, }) {
    var _a;
    if (!isViewershipPlatform(platform)) {
        return 0;
    }
    const platformViewership = getPlatformViewership({
        platform,
        averageCcv,
        averageYoutubeViews,
        averageYoutubeShortsViews,
        tiktokFollowers,
    });
    const breakpoints = (_a = campaign.viewershipBreakpoints) === null || _a === void 0 ? void 0 : _a[platform];
    if (!breakpoints) {
        return Infinity;
    }
    return getBreakpoint(breakpoints, platformViewership);
}
function getPlatformViewership({ averageCcv, averageYoutubeViews, averageYoutubeShortsViews, tiktokFollowers, platform, }) {
    if (platform === DarePlatform.Twitch) {
        return averageCcv;
    }
    if (platform === DarePlatform.YouTube) {
        return averageYoutubeViews;
    }
    if (platform === DarePlatform.TikTok) {
        return tiktokFollowers;
    }
    if (platform === DarePlatform.YouTubeShorts) {
        return averageYoutubeShortsViews;
    }
    return 0;
}
export function calculateMaxDaresForBestPlatform({ averageCcv, averageYoutubeViews, tiktokFollowers, averageYoutubeShortsViews, campaign, connectedPlatforms, }) {
    var _a;
    if (connectedPlatforms.length === 0) {
        return null;
    }
    const maxDaresByViewershipPlatforms = platformsToViewershipPlatforms(connectedPlatforms).map((platform) => {
        return {
            maxDares: calculateMaxDaresByPlatform({
                averageCcv,
                averageYoutubeViews,
                averageYoutubeShortsViews,
                tiktokFollowers,
                campaign,
                platform,
            }),
            platform,
        };
    });
    if (!maxDaresByViewershipPlatforms.length) {
        return null;
    }
    return (_a = maxBy(maxDaresByViewershipPlatforms, x => x.maxDares)) !== null && _a !== void 0 ? _a : null;
}
